function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LANG } from '../utils/constant';
import { translateFieldName } from '../utils/helpers';
import _deburr from 'lodash/deburr';
import _orderBy from 'lodash/orderBy';
import DelayMouseOver from '../utils/DelayMouseOver';

var CategoriesMenu = /*#__PURE__*/function (_Component) {
  _inherits(CategoriesMenu, _Component);

  var _super = _createSuper(CategoriesMenu);

  function CategoriesMenu(props) {
    var _this;

    _classCallCheck(this, CategoriesMenu);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setActiveCategory", function (activeCategory) {
      _this.setState({
        activeCategory: activeCategory,
        activeSubCategory: _this.state.categories.find(function (category) {
          return category.id === activeCategory;
        }).sub_categories[0].id
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setActiveSubCategory", function (activeSubCategory) {
      _this.setState({
        activeSubCategory: activeSubCategory
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSubcategories", function (categoryId) {
      return _this.state.categories.find(function (category) {
        return category.id === categoryId;
      }).sub_categories;
    });

    _defineProperty(_assertThisInitialized(_this), "getSubSubcategories", function (subCategoryId) {
      return _this.state.categories.find(function (category) {
        return category.id === _this.state.activeCategory;
      }).sub_categories.find(function (subCategory) {
        return subCategory.id === subCategoryId;
      }).sub_sub_categories;
    });

    _defineProperty(_assertThisInitialized(_this), "checkImageLink", function (image) {
      return image !== null;
    });

    _this.state = {
      activeCategory: 0,
      activeSubCategory: 0,
      activeSubSubCategory: 0,
      categories: []
    };
    return _this;
  }

  _createClass(CategoriesMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var categories = this.props.categories.map(function (category) {
        category.sub_categories = _orderBy(category.sub_categories, [function (subCategory) {
          return _deburr(subCategory[translateFieldName('name')].toLowerCase());
        }]);
        category.sub_categories.map(function (subCategory) {
          subCategory.sub_sub_categories = _orderBy(subCategory.sub_sub_categories, [function (subSubCategory) {
            return _deburr(subSubCategory[translateFieldName('name')].toLowerCase());
          }]);
          return subCategory;
        });
        return category;
      });
      this.setState({
        categories: categories,
        activeCategory: categories[0].id,
        activeSubCategory: categories[0].sub_categories[0].id
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          activeCategory = _this$state.activeCategory,
          activeSubCategory = _this$state.activeSubCategory,
          categories = _this$state.categories;
      return categories.length ? /*#__PURE__*/React.createElement("div", {
        className: "container categories-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row d-flex"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-column"
      }, categories.map(function (category) {
        return category[translateFieldName('name')] ? /*#__PURE__*/React.createElement(DelayMouseOver, {
          className: "category-link ".concat(activeCategory === category.id ? 'active' : ''),
          key: category.id,
          onMouseOver: function onMouseOver() {
            return _this2.setActiveCategory(category.id);
          }
        }, /*#__PURE__*/React.createElement("a", {
          onClick: _this2.props.closeMenu,
          href: "/".concat(LANG, "/shop/#/category/").concat(activeCategory)
        }, category[translateFieldName('name')]), /*#__PURE__*/React.createElement("i", {
          className: "fa fa-angle-right"
        })) : null;
      })), /*#__PURE__*/React.createElement("div", {
        className: "menu-column"
      }, this.getSubcategories(activeCategory).map(function (subCategory) {
        return subCategory[translateFieldName('name')] ? /*#__PURE__*/React.createElement(DelayMouseOver, {
          key: subCategory.id,
          className: "category-link ".concat(activeSubCategory === subCategory.id ? 'active' : ''),
          onMouseOver: function onMouseOver() {
            return _this2.setActiveSubCategory(subCategory.id);
          }
        }, /*#__PURE__*/React.createElement("a", {
          onClick: _this2.props.closeMenu,
          href: "/".concat(LANG, "/shop/#/category/").concat(activeCategory, "+").concat(activeSubCategory)
        }, subCategory[translateFieldName('name')]), /*#__PURE__*/React.createElement("i", {
          className: "fa fa-angle-right"
        })) : null;
      })), /*#__PURE__*/React.createElement("div", {
        className: "menu-column"
      }, this.getSubSubcategories(activeSubCategory).map(function (subSubCategory) {
        return subSubCategory[translateFieldName('name')] ? /*#__PURE__*/React.createElement("a", {
          key: subSubCategory.id,
          className: "category-link",
          href: "/".concat(LANG, "/shop/#/category/").concat(activeCategory, "+").concat(activeSubCategory, "+").concat(subSubCategory.id),
          onClick: _this2.props.closeMenu
        }, /*#__PURE__*/React.createElement("span", {
          className: "main-txt-hover"
        }, subSubCategory[translateFieldName('name')])) : null;
      })))) : null;
    }
  }]);

  return CategoriesMenu;
}(Component);

CategoriesMenu.propTypes = {
  categories: PropTypes.array,
  closeMenu: PropTypes.func
};
export default CategoriesMenu;